export var MARKERS = {
    FIRST_MONTH: Symbol("firstMonth"),
    SECOND_MONTH: Symbol("secondMonth"),
};
//# sourceMappingURL=markers.js.map